// extracted by mini-css-extract-plugin
export default {"quickGoList":"quickMenu_quickGoList__2JGt8","quickGoItem":"quickMenu_quickGoItem__GBsMd","icon":"quickMenu_icon__8QzUu","name":"quickMenu_name__5lDmH"};